export const profile = {
    name: "Nguyễn Đình Tuấn",
    job: "Frontend Developer",
    about: "Tôi là một lập trình viên frontend, chuyên về ReactJS và các công nghệ web khác.",
    location: "114/188 Tô Ngọc Vân, Gò Vấp, HCM.",
    phone: "123456789",
    email: "tuanndps36835@fpt.edu.vn",
    address: "浙江省杭州市",
    softSkills: ["Giỏi giao tiếp", "Kĩ năng xử lý cao", "Tay nghề cứng", "Ham học hỏi", "Thích nghi tốt"]
};